import React, { useMemo } from 'react';

import { Link } from 'react-router-dom';

import { AsyncTable } from 'components/AsyncTable';
import { useLegacyApiTableProps } from 'components/AsyncTable/useAsyncTableProps';
import { ButtonLink } from 'components/Links';

import { routes } from 'utils/routes';
import { idColumn, orderAndQuoteColumns } from 'utils/tables';

export const TopOpenOrders = () => {
  const columns = useMemo(
    () => [
      idColumn({
        title: 'Order No',
        dataIndex: 'orderNo',
        render: (orderNo: string) => <Link to={routes.orders.orderDetails(orderNo)}>{orderNo} </Link>,
      }),
      ...orderAndQuoteColumns({ type: 'order' }),
      {
        render: ({ orderNo }: { orderNo: string }) => ButtonLink(routes.orders.orderDetails(orderNo)),
      },
    ],
    [],
  );

  return (
    <AsyncTable
      tableProps={useLegacyApiTableProps({
        apiPath: '/v3/orders/top',
      })}
      columns={columns}
      rowKey="orderNo"
      pagination={false}
    />
  );
};
